import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faMap, faXmark } from '@fortawesome/free-solid-svg-icons'

import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom'
import { Select } from '../../../../../../../../../../../../Components/CustomUi/Select'
import { ContainerSelecao, FooterSelecao } from './styled'

interface Props {
  abrir: boolean
  /** Coleções (talhões) encontradas no arquivo importado. */
  colecoes: any[]
  /** Índice da coleção escolhida em `colecoes`. */
  selecionada: number | null
  /** `null` quando o usuário limpa a seleção pelo botão de limpar do Select. */
  aoSelecionar: (indice: number | null) => void
  aoConfirmar: () => void
  aoCancelar: () => void
}

/**
 * Um zip pode conter a malha de vários talhões (um shapefile por talhão), mas a
 * OS aceita apenas um. Este modal deixa o usuário escolher qual importar.
 * Portado da versão em produção (`ordemLaboratorio/index.tsx:484-490, 1889-1931`).
 */
export const SelecionarTalhaoMalha: React.FC<Props> = ({
  abrir,
  colecoes,
  selecionada,
  aoSelecionar,
  aoConfirmar,
  aoCancelar,
}) => {
  const [aberto, setAberto] = useState(false)
  const [rotulo, setRotulo] = useState('')

  /** O Select do CustomUi consome uma lista de itens com cod + nome. */
  const itens = useMemo(
    () =>
      (colecoes ?? []).map((colecao, index) => ({
        cod: index,
        nome: `${colecao?.fileName ?? `Talhão ${index + 1}`} (${
          colecao?.features?.length ?? 0
        } pontos)`,
      })),
    [colecoes]
  )

  // Cada abertura começa sem escolha — o modal é reaproveitado entre importações.
  useEffect(() => {
    if (abrir) {
      setRotulo('')
      setAberto(false)
    }
  }, [abrir])

  return (
    <Modal
      open={abrir}
      onCancel={aoCancelar}
      title='Selecione o talhão'
      width={520}
      footer={false}
      destroyOnClose
      zIndex={9999}
    >
      <ContainerSelecao>
        <p className='texto__selecao'>
          O arquivo contém a malha de vários talhões. A OS aceita apenas um talhão, selecione qual
          deseja importar:
        </p>

        <Select
          placeholder='Selecione o talhão'
          icon={faMap}
          value={rotulo}
          onChange={(v) => setRotulo(v as string)}
          onChangeID={(id) => aoSelecionar(id === null ? null : Number(id))}
          open={aberto}
          trigger={setAberto}
          items={itens}
          descricaoItem='nome'
          idItem='cod'
        />

        <FooterSelecao>
          <ButtonCustom
            onClick={aoCancelar}
            type='secondary'
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
          >
            Cancelar
          </ButtonCustom>
          <ButtonCustom
            onClick={aoConfirmar}
            type='primary'
            icon={<FontAwesomeIcon icon={faCheck} />}
            disabled={selecionada === null}
          >
            Importar
          </ButtonCustom>
        </FooterSelecao>
      </ContainerSelecao>
    </Modal>
  )
}
